import React,{useState,useEffect} from 'react'
import Lottie from 'lottie-react'
import ReactTypingEffect from 'react-typing-effect'
import Footer from '../Components/Footer'
import workingAnimation from '../assets/working.json'
import Navbar from '../Components/Navbar'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Tabs, Accordion, Spinner } from 'flowbite-react';
import { HiAdjustments, HiClipboardList, HiUserCircle } from 'react-icons/hi';
import { MdDashboard,MdOfflinePin } from 'react-icons/md';
import {PiExamFill} from 'react-icons/pi'
import HandiCraftsAlumni from '../data/HandicraftsAlumni.js'
import axios from 'axios'
import AlumniTable from '../Components/AlumniTable'
import CourseVideos from '../Components/CourseVideos'
import OfflineClasses from '../Components/OfflineClasses'
import CourseEvaluation from '../Components/CourseEvaluation'
import CourseFAQ from '../Components/CourseFAQ'
//<ReactTypingEffect speed={0.5} eraseSpeed={1} cursor={"_"} text={[""]}></ReactTypingEffect>
export default function Classes() {
  /**
   * https://i.postimg.cc/T1GDtZtZ/image-1.png
      https://i.postimg.cc/15mFw1nF/image-2.png
      https://i.postimg.cc/1Rc683tP/image-4.png
      https://i.postimg.cc/KjNgwJV4/image-5.png
   */
  const pathParam=useParams()
  const navigator = useNavigate()
  const switchPath = (pathname) => {
    navigator(pathname)
  }  
  const [loading,setLoading]=useState(true)
  const [data,setData]=useState()
  const [lan, setLan] = useState('bangla')
  const baseURL="https://mukti-backend-bd.onrender.com"
  const getData = async()=>{
      console.log(pathParam)
      try{
        const res = await axios.get(`${baseURL}/course/${pathParam.id}`)
        setData(res.data)
        setLoading(false)
      }catch(e){
        console.log(e)
      }
    }
    useEffect(()=>{
      if (localStorage.getItem('language') === 'english') {
        setLan('english')
        } else {
        setLan('bangla')
        }
      getData()
    },[])
    
  return loading? <Spinner/> : (
    <div className="flex flex-row min-h-screen dark:bg-gray-900">
      <Navbar />
      <div className="flex flex-row flex-wrap hidden md:flex items-center justify-between items-center py-8 px-4 mx-auto max-w-screen-sm xl:gap-16 md:grid md:grid-cols-1 sm:py-16 lg:px-6">
        {/** CARD */}

        <div class="items-center py-8 px-4 ">
          <div class="max-w-sm bg-white border border-gray-500 rounded-lg shadow-lg dark:bg-gray-700 dark:border-gray-700">
            {lan=="english" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">TRACK {data.track_id}</h5>}
            {lan=="bangla" && <h5 class="mt-4 text-2xl text-center font-bold tracking-tight text-gray-900 dark:text-white">ট্র্যাক {data.track_id}</h5>}
           {lan=="english" && <h5 class="mb-4 text-3xl text-center font-bold tracking-tight text-gray-900 text-primary-500">{data.course_name}</h5>}
           {lan=="bangla" && <h5 class="mb-4 text-3xl text-center font-bold tracking-tight text-gray-900 text-primary-500">{data.course_name_bangla}</h5>}

            <img class="w-full mb-8" src="https://i.postimg.cc/T1GDtZtZ/image-1.png" alt="" />


          </div>
        </div>

      </div>
      <div class="bg-white mt-40 dark:bg-gray-900">
        <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-2xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
          <div class="mt-4 md:mt-0">
            {lan=="english" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">TRACK {data.track_id} : {data.course_name}</span></h2>}
            {lan=="english" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">{data.description}</p>}

            {lan=="bangla" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">ট্র্যাক {data.track_id} : {data.course_name_bangla}</span></h2>}
            {lan=="bangla" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">{data.description_bangla}</p>}
          </div>
        </div>

        <Tabs.Group
          aria-label="Full width tabs"
          style="fullWidth"
        >
          
          <Tabs.Item
            icon={MdDashboard}
            title="Dashboard"
            className='border border-0'
          >
            {/**DASHBOARD */}
            <CourseVideos course_id={data.course_id}/>
          </Tabs.Item>

          <Tabs.Item
            icon={HiClipboardList}
            title="FAQ"
          >
            <CourseFAQ course_id={data.course_id}/>
          </Tabs.Item>
          <Tabs.Item
            icon={MdOfflinePin}
            title="Upcoming"
          >
            <OfflineClasses course_id={data.course_id}/>
          </Tabs.Item>

          <Tabs.Item
            icon={PiExamFill}
            title="Assessment"
          >
            <CourseEvaluation course_id={data.course_id}/>
          </Tabs.Item>
          <Tabs.Item
            active
            icon={HiUserCircle}
            title="Alumni"
          >
            {/** TABLE */}
            <AlumniTable course_id={data.course_id}/>
          </Tabs.Item>
        </Tabs.Group>



      </div>




    </div>

  )
}
